import { STATUS_TYPE } from '../../../enum';

export interface GetLocationManagement {
  id: string;
}

export interface FindLocationManagement {
  limit?: number;
  skip?: number;
}

export interface CreatePatchLocationManagement {
  id?: string;
  code: string;
  labelEn: string;
  labelAr: string;
  position: string;
  activeState: boolean;
  latitude: number;
  longitude: number;
}

export interface LocationManagement {
  id: string;
  code: string;
  labelEn: string;
  labelAr: string;
  position: string;
  activeState: boolean;
  latitude: number;
  longitude: number;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: LocationManagement[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
